import React, { memo, useEffect, useState } from 'react'
import { Link, HeadingText } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import DsrBanner from '../common/dsr-banner'
import { ZETTLE_US_URL } from '../../../constants/constants'
import { fptiCustomSetup, fptiCustomClick } from '../../../utils'

const DSRSuccess = memo((props) => {
  const [impressionDone, setImpressionDone] = useState(false)
  const { dsrFpti = {} } = props

  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomSetup(dsrFpti.CASECREATION_SUCCESS_IMPRESSION)
    }
  }, [impressionDone, dsrFpti])
  const bannerContent = {
    header: <Message id="dsrZettle.success.header.title" />,
    description: '',
  }
  const handleLinkClick = () => {
    fptiCustomClick(dsrFpti.CASECREATION_SUCCESS_LINKCLICK)
  }
  return (
    <>
      <DsrBanner {...bannerContent} />
      <section className="page-body-container">
        <div className="inner-container">
          <section className="common-screen">
            <HeadingText size="sm" className="text-center">
              <Message id="dsrZettle.success.body.title" />
            </HeadingText>
            <p className="text-center margintop16">
              <Message id="dsrZettle.success.body.description" />
            </p>
            <p className="text-center">
              <Message
                id="dsrZettle.success.body.confirmation"
                link={(innerMessage) => (
                  <Link
                    href={ZETTLE_US_URL}
                    onClick={handleLinkClick}
                    theme="v2"
                  >
                    {innerMessage}
                  </Link>
                )}
              />
            </p>
          </section>
        </div>
      </section>
    </>
  )
})
DSRSuccess.displayName = 'DSRSuccess'

export default DSRSuccess
